import { Title, BreadCrumb } from "@funcional/react-ui";
import { useEmbedUrl } from "@pbm/tableau/hooks";

export default function ListDashboardPage() {
  const { data } = useEmbedUrl();
  const embedUrl = data?.embedUrl;
  return (
    <>
      <div className="flex w-full items-center mb-4">
        <div className="flex-1">
          <Title>Dashboard</Title>
        </div>
      </div>

      <BreadCrumb items={[{ label: "Dashboard" }]} />
      <div className="relative overflow-hidden w-full pt-[56.25%]">
        <iframe
          title="myTableau"
          className="absolute top-0 left-0 bottom-0 right-0 w-full h-[calc(100%-4rem)]"
          src={embedUrl}
        ></iframe>
      </div>
    </>
  );
}
